import { useState } from 'react';
import JobListingForm from '../components/forms/PostJob';
import ApplicantForm from '../components/forms/ApplicantForm';
import { postJobListing } from '../hooks/mutations';
import { JobListing } from '../types/jobs';
import { fetchJobListings } from '../hooks/queries';
import { useNavigate, useParams } from 'react-router-dom';

interface PostJobFlowProps {
  onSuccess?: (data: any) => void;
  onError?: (error: Error) => void;
}

const PostJobFlow: React.FC<PostJobFlowProps> = ({ onSuccess, onError }) => {
  const { data: jobListings, refetch } = fetchJobListings();

  const [step, setStep] = useState(1);
  const [jobData, setJobData] = useState<JobListing | null>(null);
  const navigate = useNavigate();
  const { category } = useParams();

  const { mutate: postJobMutation, isPending: isSubmitting } = postJobListing({
    onSuccess: (data) => {
      onSuccess?.(data);
      navigate('/job-listings');
      refetch();
    },
    onError: (e) => onError?.(e),
  });

  const handleJobSubmit = (data: JobListing) => {
    setJobData(data);
    setStep(2);
  };

  const handleFinalSubmit = async (metadata: any) => {
    if (jobData) {
      const combinedData = { ...jobData, metadata, category: category || '' };

      try {
        postJobMutation(combinedData);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="max-w-5xl 2xl:max-w-7xl mx-auto">
      {step === 1 ? (
        <JobListingForm onSubmit={handleJobSubmit} />
      ) : (
        <ApplicantForm
          onSubmit={handleFinalSubmit}
          isSubmitting={isSubmitting}
          jobListings={jobListings?.data ?? []}
        />
      )}
    </div>
  );
};

export default PostJobFlow;
